var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70031 2.85826C4.93087 1.24234 6.32037 0 8.00004 0C9.68044 0 11.0704 1.24341 11.3001 2.86036C13.1153 3.01022 14.6665 4.817 14.6665 7.1108C14.6665 10.7926 11.3332 14.3326 7.99994 15.9988C4.66327 14.3304 1.33337 10.7926 1.33337 7.1108C1.33337 4.81767 2.88553 3.00929 4.70031 2.85826ZM10.6285 2.88129C10.4138 1.62383 9.31871 0.666667 8.00004 0.666667C6.68221 0.666667 5.58767 1.62258 5.37194 2.87883C6.11374 2.98636 6.87237 3.3803 7.56597 4.1351L7.69064 4.27553C7.69064 4.27553 7.89867 4.52833 7.99994 4.66783C8.10141 4.5285 8.30981 4.276 8.30981 4.276L8.43471 4.13573C9.12874 3.3825 9.88717 2.98903 10.6285 2.88129ZM7.99997 15.2486C11.3904 13.4417 13.9998 10.1137 13.9998 7.11087C13.9998 3.72573 10.6313 2.18726 8.53884 5.06037L7.99911 5.80147L7.46047 5.05957C5.37257 2.18368 2.00004 3.7249 2.00004 7.11087C2.00004 10.1145 4.60727 13.4403 7.99997 15.2486Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.2dd7b9e67f50f2f9bbdd4ce601f247f6.svg";
export { ForwardRef as ReactComponent };